import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCloudImageUrl, isFromKickApp } from '../../utils';
import { Container, Row, Col } from 'reactstrap';
// import KickLogoWhite from "../../images/kick-logo-white.png"
// import KickLogoWhite from "../../images/kick-logo-white-new.png"
import KickLogoWhite from '../../images/footer-icon.png';
import IGStreetwear from '../../images/ig-streetwear.png';
import IGLuxury from '../../images/ig-luxury.png';
import IGLifestyle from '../../images/ig-lifestyle.png';
import GreyIG from '../../images/footer-ig.png';
import GreyYt from '../../images/footer-yt.png';
import GreyFb from '../../images/footer-fb.png';
import GreyTt from '../../images/footer-tt.png';
import GreenInstagram from '../../images/green-instagram.png';
import GreenFacebook from '../../images/green-facebook.png';
import GreenTiktok from '../../images/green-tiktok.png';
import GreenYoutube from '../../images/green-youtube.png';
// import AppDownload from "../../images/app-download.png"
import AppDownload from '../../images/footer-phone-display.png';
import AppDownloadMobile from '../../images/footer-phone-display-mobile.png';
import GooglePlayWhite from '../../images/footer-playstore.png';
import AppStoreWhite from '../../images/footer-appstore.png';
import WhiteLocator from '../../images/locator-icon.png';
import WhiteArrowDown from '../../images/open-select.png';
import ModalPaymentConfirmation from '../Modals/ModalPaymentConfirmation';
import { hideNavbarSub } from '../../utils/Helpers';
import { handleShowFooter } from '../../actions/globalAction';

const homepageUrl = [
  '/',
  '/sneakers',
  '/apparel',
  '/luxury',
  '/madeindonesia',
  '/lifestyles',
  '/electronics-collectibles',
];

function FooterV3({ history, handleShowFooter, globalValue }) {
  const [_showFooter, set_ShowFooter] = useState(true);
  const [isModalConfirmationOpened, setIsModalConfirmationOpened] =
    useState(false);

  const toggleModalPayemntConfirmation = () =>
    setIsModalConfirmationOpened(!isModalConfirmationOpened);

  const renderModalPaymentConfirmation = () => (
    <ModalPaymentConfirmation
      isOpen={isModalConfirmationOpened}
      onToggle={toggleModalPayemntConfirmation}
      paymentInfo={{
        invoiceNumber: '',
        transferAmount: 0,
      }}
      callback={toggleModalPayemntConfirmation}
    />
  );

  function openPlayStore() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.kickavenue.androidshop&hl=in',
      '_blank',
    );
  }

  function openAppStore() {
    window.open(
      'https://apps.apple.com/id/app/kickavenue-shop-collectibles/id1478394222',
      '_blank',
    );
  }

  function redirectSocialMedia(url) {
    window.open(url, '_blank');
  }

  useEffect(() => {
    const isHomepage = homepageUrl.filter(
      (url) => url === history.location.pathname,
    );
    if (isHomepage.length > 0) {
      set_ShowFooter(true);
    } else {
      set_ShowFooter(false);
    }
  }, [history.location.pathname]);

  // if(globalValue.showFooter) return <div></div>
  if (!_showFooter) return <div></div>;

  if (window.screen.availWidth < 480) {
    return (
      <div className="footer-v3-mobile">
        <div className="footer-logo">
          <KickImage alt="Kick Avenue Logo" src={KickLogoWhite} />
          <div className="footer-title">
            <h4>200% Money Back Guarantee</h4>
            <h4 className="company-tagline">Authentic. Guaranteed.</h4>
          </div>
        </div>
        <div className="footer-option">
          <a href="/helps/general-faq">FAQ</a>
          <a href="/helps/privacy-policy">Privacy Policy</a>
          <p onClick={toggleModalPayemntConfirmation}>Payment Confirmation</p>
          <a
            href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODg5NDAwMDEyNTE3Mzk4?story_media_id=2297918794025445222&utm_medium=copy_link"
            target="_blank"
          >
            Buying & Selling Guide
          </a>
          <a href="/kickavenews">Kickavenews</a>
        </div>
        <div className="explore-us">
          <div className="explore-title">
            <h4>Explore us more on Instagram!</h4>
          </div>
          <div className="explore-options">
            <a
              href="https://www.instagram.com/kick.avenue/"
              target="_blank"
              className="explre-option"
            >
              <KickImage alt="" src={GreyIG} />
              <h5>Kick Avenue</h5>
            </a>
            <a
              href="https://www.instagram.com/kickavenue.studio/"
              target="_blank"
              className="explre-option"
            >
              <KickImage alt="" src={GreyIG} />
              <h5>
                Kick Avenue <span>Studio</span>
              </h5>
            </a>
            {/* <a
              href="https://www.instagram.com/kickavenue.lifestyle/"
              target="_blank"
              className="explre-option"
            >
              <KickImage alt="" src={GreyIG} />
              <h5>
                Kick Avenue <span>Lifestyle</span>
              </h5>
            </a> */}
          </div>
        </div>
        <div className="keep-in-touch">
          <div className="keep-in-touch-title">
            <h5>Keep in touch with us!</h5>
          </div>
          <div className="social-icons">
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://instagram.com/kick.avenue')
              }
              src={GreyIG}
              alt="instagram"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia(
                  'https://www.youtube.com/channel/UCxLcZeJaQuGicSpDBmAug6g',
                )
              }
              src={GreyYt}
              alt="youtube"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.facebook.com/kickavenueid/')
              }
              src={GreyFb}
              alt="facebook"
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.tiktok.com/@kickavenue?')
              }
              src={GreyTt}
              alt="tik tok"
            />
          </div>
          {/* <div className="languages-select">
            <select name="languages" id="footer-languages-mobile">
              <option value="Indonesia">Indonesia</option>
              <option value="English">English</option>
            </select>
          </div> */}
        </div>
        <div className="download-app">
          <div className="image-download">
            <KickImage src={AppDownloadMobile} alt="phone download image" />
          </div>
          <div className="call-to-action">
            <div>
              <h5>Download Our App</h5>
            </div>
            <div className="img-download-button">
              <KickImage
                onClick={() => openAppStore()}
                style={{ marginBottom: '10px' }}
                src={AppStoreWhite}
                alt="kickavenue apple store"
              />
              <KickImage
                onClick={() => openPlayStore()}
                src={GooglePlayWhite}
                alt="kickavenue google play"
              />
            </div>
          </div>
        </div>
        <div className="registered">
          <h5>
            REGISTERED UNDER <br />
            <span>PT. KARUNIA INTERNASIONAL CITRA KENCANA</span>
          </h5>
        </div>
        {renderModalPaymentConfirmation()}
      </div>
    );
  }

  return (
    <footer className="footer-version-3">
      <div className="nav-footer">
        <div className="kick-logo">
          <KickImage src={KickLogoWhite} alt="" />
          <div>
            <h6>200% Money Back Guarantee</h6>
            <h4>Authentic. Guaranteed.</h4>
          </div>
        </div>
        <div className="kick-option">
          <a href="/helps/general-faq">FAQ</a>
          <a href="/helps/privacy-policy">Privacy Policy</a>
          <p onClick={toggleModalPayemntConfirmation}>Payment Confirmation</p>
          <a
            href="https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODg5NDAwMDEyNTE3Mzk4?story_media_id=2297918794025445222&utm_medium=copy_link"
            target="_blank"
          >
            Buying & Selling Guide
          </a>
          <a className="mb-0" href="/kickavenews">
            Kickavenews
          </a>
        </div>
        <div className="kick-social-child">
          <h2>Explore us more on Instagram!</h2>
          <a href="https://www.instagram.com/kick.avenue/" target="_blank">
            <KickImage src={GreyIG} alt="Kick Avenue Instagram" />
            <p>Kick Avenue</p>
          </a>
          <a
            href="https://www.instagram.com/kickavenue.studio/"
            target="_blank"
          >
            <KickImage src={GreyIG} alt="Kick Avenue Studio" />
            <p>
              Kick Avenue <span>Studio</span>
            </p>
          </a>
          {/* <a
            href="https://www.instagram.com/kickavenue.lifestyle/"
            target="_blank"
          >
            <KickImage src={GreyIG} alt="Kick Avenue Lifestyle" />
            <p>
              Kick Avenue <span>Lifestyle</span>
            </p>
          </a> */}

          <div style={{ marginBottom: 16 }} />
        </div>
        <div className="kick-social">
          <h2>Keep in touch with us!</h2>
          <div>
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://instagram.com/kick.avenue')
              }
              src={GreyIG}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia(
                  'https://www.youtube.com/channel/UCxLcZeJaQuGicSpDBmAug6g',
                )
              }
              src={GreyYt}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.facebook.com/kickavenueid/')
              }
              src={GreyFb}
              alt=""
            />
            <KickImage
              onClick={() =>
                redirectSocialMedia('https://www.tiktok.com/@kickavenue?')
              }
              src={GreyTt}
              alt=""
            />
          </div>

          <div style={{ marginBottom: 16 }} />
          <div style={{ marginBottom: 16 }} />
          {/* <div>
            <KickImage className="white-arrow" src={WhiteArrowDown} alt="" />
            <KickImage className="white-locator" src={WhiteLocator} alt="" />
            <select name="languages" id="footer-languages">
              <option value="Indonesia">Indonesia</option>
              <option value="English">English</option>
            </select>
          </div> */}
        </div>
        <div className="kick-app-img">
          <KickImage src={AppDownload} alt="" />
        </div>
        <div className="kick-download">
          <h2>Download Our App</h2>
          <div className="img-download-button">
            <KickImage
              onClick={() => openAppStore()}
              style={{ marginBottom: '10px' }}
              src={AppStoreWhite}
              alt="kickavenue apple store"
            />
            <KickImage
              onClick={() => openPlayStore()}
              src={GooglePlayWhite}
              alt="kickavenue google play"
            />
          </div>
        </div>
      </div>
      <div className="registered">
        <h4>
          REGISTERED UNDER <span>PT. KARUNIA INTERNASIONAL CITRA KENCANA</span>
        </h4>
      </div>
      {renderModalPaymentConfirmation()}
    </footer>
  );
}

const mapStateToProps = (state) => ({
  globalValue: state.globalValue,
});

const mapDispatchToProps = (dispatch) => ({
  handleShowFooter: (payload) => dispatch(handleShowFooter(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(FooterV3));
